import { all, takeLatest } from 'redux-saga/effects';

import { signInSaga } from './signInSaga';
import { sendTemporaryPasswordSaga } from './sendTemporaryPasswordSaga';
import { logoutSaga } from './logoutSaga';
import { getAuthTokenSaga } from './getAuthTokenSaga';
import { getAppAccessCodeSaga } from './getAppAccessCodeSaga';
import { authenticateSaga } from './authenticateSaga';
import { authenticateByCWTTokenSaga } from './authenticateByCWTTokenSaga';
import * as actionTypes from '../actionTypes';

export { signInSaga } from './signInSaga';
export { logoutSaga } from './logoutSaga';

export default function* watchAuth() {
    yield all([
        takeLatest(actionTypes.LOG_OUT, logoutSaga),
        takeLatest(actionTypes.SIGN_IN_REQUEST, signInSaga),
        takeLatest(actionTypes.AUTHENTICATE, authenticateSaga),
        takeLatest(actionTypes.AUTHENTICATE_BY_CWT_TOKEN, authenticateByCWTTokenSaga),
        takeLatest(actionTypes.SEND_TEMPORARY_PASSWORD_REQUEST, sendTemporaryPasswordSaga),
        takeLatest(actionTypes.GET_APP_ACCESS_CODE_REQUEST, getAppAccessCodeSaga),
        takeLatest(actionTypes.GET_AUTH_TOKEN_REQUEST, getAuthTokenSaga),
    ]);
}
